<template>
  <ais-refinement-list
    :attribute="filter.id"
    :transformItems="transformItems"
    :limit="999"
    :sort-by="['name:asc']"
    operator="and"
  >
    <template v-slot="{ items, refine }">
      <div class="icon-filter">
        <div class="filter-values">
          <span v-for="item in items" class="filter-value-wrapper" :key="item.value">
            <span
              ref="test"
              class="filter-value"
              :class="{ active: item.isRefined }"
              :style="{backgroundImage: getIconPath(filter.id, item.value)}"
              data-toggle="tooltip"
              data-placement="bottom"
              :title="item.title ? item.title : item.label"
              @click="handleClick(refine, item)"
            ></span>
          </span>
        </div>
      </div>
    </template>
  </ais-refinement-list>
</template>

<script>
import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';
import {convertNameToPath} from '../../main/utils';
import {filterTranslations} from '../filter-translations';
import {transformItems, scrollToTopAfterFilterChange} from '../filters-config';

const imageIcons = ['product_spout_design', 'product_product_line'];
const emptyIcons = ['mixer-not-included', 'no-line'];

export default {
  props: {
    filter: {type: Object, required: true}
  },
  watch: {
    $mq() {
      this.handleTooltips();
    }
  },
  mounted() {
    setTimeout(this.handleTooltips, 100);
  },
  updated() {
    this.handleTooltips();
  },
  methods: {
    handleClick(refine, item) {
      refine(item.value);
      scrollToTopAfterFilterChange();
    },
    handleTooltips() {
      if (this.$mq === 'md') {
        $('[data-toggle="tooltip"]').tooltip('destroy');
      } else {
        $('[data-toggle="tooltip"]').tooltip();
      }
    },
    transformItems(items) {
      return transformItems(this.filter, items);
    },
    getIconPath(filterId, name) {
      let iconName = convertNameToPath(name);
      let iconExtension = 'svg';

      if (!this.isImageIconFilter(filterId)) {
        Object.keys(filterTranslations).find(key => {
          if (filterTranslations[key].includes(name)) {
            iconName = key;
          }
        });
      }

      if (this.isImageIconFilter(filterId)) iconExtension = 'jpg';
      if (this.isGuidedHandwashingDisplayFilter(filterId))
        iconName = 'guided-handwashing-display';

      const iconFile = emptyIcons.includes(iconName)
        ? 'filter-icon-none.svg'
        : `filter-icon-${iconName}.${iconExtension}?v2`;

      return `url(/themes/sloan/img/${iconFile})`;
    },
    isImageIconFilter(filterId) {
      return imageIcons.includes(filterId);
    },
    isGuidedHandwashingDisplayFilter(filterId) {
      return filterId === 'product_guided_handwashing_display';
    }
  }
};
</script>
